import React from 'react';
import { Grid } from 'react-bootstrap';
import _ from 'lodash';
import { connect } from 'react-redux';

import Slide from './Slide';
import Greeting from './Greeting';
import Features from './Features';
import Book from './Book';
import MobileApp from './MobileApp';
import SubscriptionMethods from './SubscriptionMethods';
import About from './About';

class Landing extends React.Component {
  state = {
    mobile: false,
    height: 0,
  };

  componentDidMount() {
    document.body.classList.add('landing');
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    document.body.classList.remove('landing');
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    const mobile = window.matchMedia('(max-width: 767px)').matches;

    if (mobile === this.state.mobile) return;

    this.setState({ mobile });
  };

  handleScroll = (direction: number): void => {
    if (this.state.mobile) {
      return;
    }

    const { slides, landingScrollPosition } = this.props;

    const currentSlideIndex = slides.findIndex(slide => slide === landingScrollPosition);
    const nextSlideIndex = direction > 0 ? currentSlideIndex + 1 : currentSlideIndex - 1;

    if (nextSlideIndex < 0 || nextSlideIndex >= slides.length) return;

    const el = document.getElementById(slides[nextSlideIndex]);

    el && el.scrollIntoView({ block: 'start', behavior: 'smooth' });
  };

  debounceInterval = !!document.documentMode ? 400 : 40; // check if IE and set different interval

  handleWheelMove = _.debounce(
    (direction: number): void => {
      this.handleScroll(direction);
    },
    this.debounceInterval,
    { leading: true, trailing: false },
  );

  render() {
    return (
      <Grid fluid className="hidden-scrollbar if-no-flex-main" id="landingContainer">
        <Slide id="greeting" handleScroll={this.handleScroll} handleWheelMove={this.handleWheelMove}>
          <Greeting />
        </Slide>

        <Slide id="about" handleScroll={this.handleScroll} handleWheelMove={this.handleWheelMove}>
          <About />
        </Slide>

        <Slide id="features" handleScroll={this.handleScroll} handleWheelMove={this.handleWheelMove}>
          <Features />
        </Slide>

        <Slide id="mobile-app" handleScroll={this.handleScroll} handleWheelMove={this.handleWheelMove}>
          <MobileApp />
        </Slide>

        <Slide id="subscription-plans" handleScroll={this.handleScroll} handleWheelMove={this.handleWheelMove}>
          <SubscriptionMethods />
        </Slide>

        <Slide id="book" handleScroll={this.handleScroll} handleWheelMove={this.handleWheelMove}>
          <Book />
        </Slide>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({ slides: state.slides, landingScrollPosition: state.landingScrollPosition });

export default connect(mapStateToProps)(Landing);



// WEBPACK FOOTER //
// ./src/components/Landing/Landing.js